import { Component, SimpleChanges, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { IScheduleAvailability } from '@signal/asp-data-commons/lib/interfaces/availability';
import { assetUrl } from 'src/single-spa/asset-url';
import { DateTime } from 'luxon';
import { Store } from '@ngrx/store';
import { ScheduleDashboardState } from 'src/app/modules/store/schedule-dashboard/schedule-dashboard.reducer';
import * as fromScheduleDashboardSelector from '../../../../store/schedule-dashboard/schedule-dashboard.selectors';
import { Observable } from 'rxjs';
import { cacheLimitedStartDate } from '../../../services/util.service';


@Component({
  selector: 'app-appointment-by-month',
  templateUrl: './appointment-by-month.component.html',
  styleUrls: ['./appointment-by-month.component.scss']
})
export class AppointmentByMonthComponent implements OnChanges, OnInit {

  @Input() dateArray : IScheduleAvailability[];
  @Input() selectedDate: Date;
  @Input() month: string;
  @Output() dateChange: EventEmitter<IScheduleAvailability> = new EventEmitter<IScheduleAvailability>();
  @Output() dateRangeChange: EventEmitter<IScheduleAvailability> = new EventEmitter<IScheduleAvailability>();
  @Input() department: string;
  isSlotLoading$: Observable<boolean>;

  currentDate = DateTime.now().startOf('day');
  selectedDateMonth;
  dateFormat = 'yyyy-MM-dd';
  currentSelection;
  weekdays = ['common.Mon', 'common.Tue', 'common.Wed', 'common.Thu', 'common.Fri', 'common.Sat', 'common.Sun'];
  fullCapacityUrl = assetUrl('icons/capacity-indicators/full-capacity.svg');
  halfCapacityUrl = assetUrl('icons/capacity-indicators/half-capacity.svg');
  lowCapacityUrl = assetUrl('icons/capacity-indicators/low-capacity.svg');

  constructor(private scheduleDashboardState: Store<ScheduleDashboardState>) { }

  ngOnInit(): void {
    this.isSlotLoading$ = this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardSlotLoading);
    this.selectedDateMonth = DateTime.fromFormat(this.month, 'MMMM yyyy').startOf('month');
    if (DateTime.now().month === DateTime.fromFormat(this.month, 'MMMM yyyy').month) {
      this.currentSelection = DateTime.now().startOf('day');
    } else {
    this.currentSelection =  DateTime.fromFormat(this.month, 'MMMM yyyy').startOf('month');
    }
    const index = this.dateArray.findIndex(x=> x.date.getDate() === this.currentSelection.day && 
    x.date.getMonth() === (this.currentSelection.month - 1) && x.date.getFullYear() === this.currentSelection.year)
    if(index !== -1){
      this.dateChange.emit(this.dateArray[index]);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.hasOwnProperty('month')) {
      if (changes.month.currentValue  && changes.month.currentValue !== changes.month.previousValue && changes.month.currentValue !== '') {
        if (DateTime.now().month === DateTime.fromFormat(this.month, 'MMMM yyyy').month) {
          this.selectedDateMonth = DateTime.now().startOf('day');
        } else {
          this.selectedDateMonth = DateTime.fromFormat(this.month, 'MMMM yyyy').startOf('month');
        }
        this.currentSelection = this.selectedDateMonth;
        const currentDate = new Date(this.selectedDateMonth);
        const selectIndex = this.dateArray.findIndex(x => x.date.getDate() === currentDate.getDate()
          && x.date.getMonth() === currentDate.getMonth()
          && x.date.getFullYear() === currentDate.getFullYear());
        const currentSelection = selectIndex === -1 ? 0 : selectIndex;
        setTimeout(() => {
          this.dateChange.emit(this.dateArray[currentSelection]);
        },2000);
       
      }
    }
  }

  getStatusImage(date: IScheduleAvailability){
    if(date.bookingPercentage > 75 || date.bookingPercentageHrs > 75) {
      return 'url('+this.fullCapacityUrl+')'
    } else if((date.bookingPercentageHrs > 50 && date.bookingPercentageHrs <= 75) || (date.bookingPercentage > 50 && date.bookingPercentage <= 75)){
        return 'url('+this.halfCapacityUrl+')';
    }else if(date.bookingPercentage > 0 || date.bookingPercentageHrs > 0 || date.bookingPercentageHrs === -2 || date.bookingPercentage === -2){
        return 'url('+this.lowCapacityUrl+')';
    }
  }
  
    getBackgroundColor(bookingPercent: number, type: string){
      if(bookingPercent > 0 && bookingPercent <= 50 || bookingPercent === -2 ){
        return '#0A7F2B1A';
      } else if(bookingPercent > 50 && bookingPercent <= 75){
        return '#D878081A';
      } else if(bookingPercent > 75){
        return '#A000001A';
      } else if(bookingPercent === -1 || !bookingPercent){
        return type === 'Hrs' ? 'white' :'#0E131933';
      }
    }
  

  getTransformed(date: Date) {
    return date.getDate();
  }

  getDay(date: Date) {
    return DateTime.fromISO(date.toISOString()).toFormat('EEE');
  }

  setClass(date: Date){
    const dateInLuxon = DateTime.fromISO(date.toISOString()).startOf('day');
    let selectedDateInLuxon = null;
    if(this.selectedDate){
    selectedDateInLuxon = DateTime.fromISO(this.selectedDate.toISOString()).startOf('day');
    }
    if(dateInLuxon.month !== this.selectedDateMonth.month){
      return 'hide';
    } else if(dateInLuxon.toFormat(this.dateFormat) === this.currentDate.toFormat(this.dateFormat) || 
    (selectedDateInLuxon && dateInLuxon.toFormat(this.dateFormat) === selectedDateInLuxon.toFormat(this.dateFormat))){
      if(this.currentSelection && dateInLuxon.toFormat(this.dateFormat) === this.currentSelection.toFormat(this.dateFormat)){
        return 'selected current'
      }
      return 'current';
    } else if(this.currentSelection && dateInLuxon.toFormat(this.dateFormat) === this.currentSelection.toFormat(this.dateFormat)){
      return 'selected'
    } else if(dateInLuxon < this.currentDate){
      return 'disable';
    }
    return '';
  }

  dateSelection(i: number){
    this.dateChange.emit(this.dateArray[i]);
    this.currentSelection = DateTime.fromISO(this.dateArray[i].date.toISOString()).startOf('day');
  }

  isDateWithinMonthRange(date){
    const dateInLuxon = DateTime.fromISO(date.toISOString()).startOf('day');
    const monthStartWeekDate = DateTime.fromFormat(this.month, 'MMMM yyyy').startOf('month').startOf('week');
    const monthendWeekDate = DateTime.fromFormat(this.month, 'MMMM yyyy').endOf('month').endOf('week');
    return dateInLuxon.month === this.selectedDateMonth.month || (date >= monthStartWeekDate && date <= monthendWeekDate );
  }
 
  checkDateWithinCacheLimit(date){
    return date?.date < new Date(cacheLimitedStartDate.plus({days:-1}).toFormat('yyyy-MM-dd'))
  }
}
